import script from "./DispatchOutboundLocationDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DispatchOutboundLocationDialog.vue?vue&type=script&setup=true&lang=js"

import "./DispatchOutboundLocationDialog.vue?vue&type=style&index=0&id=49a654ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49a654ae"]])

export default __exports__